module.exports = __webpack_public_path__ + "6be556413b9147fcbeaeb5a5c671b47d.svg";